<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="search">
        <el-row class="search-row">
            <el-col :span="4" class="display-row">
                <div class="query-title">模板类型:</div>
                <div class="flex1">
                    <el-select
                        v-model="queryInfo.templateType"
                        placeholder="请选择"
                        size="small"
                        clearable
                    >
                        <el-option
                        key="1"
                        value="1"
                        label="通用模板"
                        ></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="4" class="display-row">
                <div class="query-title">中文标题:</div>
                <div class="flex1">
                <el-input
                    placeholder="请输入中文标题"
                    clearable
                    v-model="queryInfo.remindingTitle"
                    size="small"
                    @keyup.enter.native="doSearch"
                >
                </el-input>
                </div>
            </el-col>

            <el-col :span="4" class="display-row">
                <div class="query-title">是否启用:</div>
                <div class="flex1">
                    <el-select
                        v-model="queryInfo.isUse"
                        placeholder="请选择"
                        size="small"
                        clearable
                    >
                        <el-option
                        key="0"
                        value="0"
                        label="启用"
                        ></el-option>
                        <el-option
                        key="1"
                        value="1"
                        label="禁用"
                        ></el-option>
                    </el-select>
                </div>
            </el-col>

            <el-col :span="8" class="display-row">
                <div class="query-title">创建时间:</div>
                <div class="flex1 lx-flex-row">
                    <el-date-picker
                        v-model="createDate"
                        type="datetimerange"
                        range-separator="至"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="lx-flex-row-end" style="text-align: right; width: 100%; padding-left: 10px">
                    <el-button class="search-btn btn-gray" @click="doReset"
                        >重置</el-button
                    >
                    <el-button class="search-btn btn-blue" @click="doSearch"
                    >搜索</el-button
                    >
                    <el-button class="search-btn btn-blue" style="margin-right: 0;!important" @click="doEdit('')"
                    >添加</el-button
                    >
                </div>
            </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
        :data="list"
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        border
        height="550">
          <el-table-column type="index" align="center" label="序号" width="40">
          </el-table-column>
          <el-table-column prop="templateType" label="模板类型" align="center" width="90">
              <template>
                  <span>通用模板</span>
              </template>
          </el-table-column>
          <el-table-column prop="remindingTitle" label="中文标题" align="center">
          </el-table-column>
          <el-table-column prop="remindingTitleJa" label="日文标题" align="center">
          </el-table-column>
          <el-table-column prop="remindingContentJa" label="模板内容" width="300">
            <template slot-scope="scope">
              <span class="temp-content" :title="scope.row.remindingContentJa">{{ scope.row.remindingContentJa }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="跳转链接" width="300">
            <template slot-scope="scope">
              <ul>
                <li v-for="(item, index) in scope.row.urls" :key="index">
                  <a :href="item" target="_blank">{{ item }}</a>
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="isUse" align="center" label="状态" width="70">
              <template slot-scope="scope">
                  <span>{{ scope.row.isUse == 1 ? '禁用' : '启用' }}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间">
            <template slot-scope="scope">
              <span>{{  scope.row.createTime | dateFormatToDay | empty }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="更新时间">
            <template slot-scope="scope">
              <span>{{ scope.row.updateTime | dateFormatToDay | empty }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                style="margin: 5px"
                class="list-btn btn-blue"
                @click="doEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                style="margin: 5px"
                class="list-btn btn-deepblue"
                @click="doSwitch(scope.row)"
                >{{ scope.row.isUse == 1 ? '启用' : '禁用' }}</el-button
              >
              <el-button
                style="margin: 5px"
                class="list-btn btn-red"
                @click="doDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>

   <EditTemp :isVisiable.sync="isVisiable" :id="curId" @confirm="onConfirm"></EditTemp>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import EditTemp from "./cmp/EditTemp.vue";

const queryInfo = {
    templateType: "", // 模板类型
    remindingTitle: "", // 中文标题
    isUse: '', // 0 启用， 1禁用启用状态
    createTimeStart: '',
    createTimeEnd: '',
    pageSize: 10,
    pageNum: 1,
}

export default {
  name: 'tempConfig',
  components: { tableCon, EditTemp },
  data() {
    return {
        queryInfo: this._.cloneDeep(queryInfo),
        createDate: [], // 创建时间
        list: [],
        total: 0,
        isVisiable: false,
        curId: null
    };
  },
  watch: {
    createDate(val) {
      if(val && val.length > 0) {
        this.queryInfo.createTimeStart = val[0]
        this.queryInfo.createTimeEnd = val[1]
      }
    }
  },
   created() {
    this.getList();
  },
  methods: {
    doSearch() {
      this.queryInfo.pageNum = 1;
      this.getList();
    },

    // 编辑
    doEdit(row) {
      this.curId = row?  row.id : null
      this.isVisiable = true
    },
    // 启用禁用
    doSwitch({ id, isUse }) {
      const params = {
        id,
        isUse: isUse == 1 ? '0' : '1'
      }
      this.$http.post("/template/message/changeStatus", params).then(() => {
        this.$message.success('操作成功！')
        this.getList()
      })
    },

    // 删除
    doDelete({ id }) {
      this.$confirm('请确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id
        }
        this.$http.get("/template/message/delete", { params }).then(() => {
          this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          this.getList()
      })
    },

    async getList() {
      const { data: res } = await this.$http.get("/template/message/list", {
        params: this.queryInfo,
      });
      res.data.list.forEach(item => {
        if (item.url) {
          item.urls = item.url.split(',')
        }
      })
      this.list = res.data.list;
      this.total = res.data.total;
    },

    // 添加/编辑回调
    onConfirm() {
      this.isVisiable = false
      this.getList()
    },

    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getList();
    },
    // 重置
    doReset() {
      this.queryInfo = this._.cloneDeep(queryInfo)
    },
  },


};
</script>

<style lang="less" scoped>
.temp-content {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  &:hover {
    cursor: default;
  }
}
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
